<template>
	<div class="dialogRecoveryStateComp">
		<el-dialog :title="'康复情况'" :visible.sync="dialogState" @close="close" width="600px" >
			<div>
				<div v-if="recoveryState===2" class="desc">该操作将归档病例，确定已治愈？</div>
				<div v-if="recoveryState===3" class="desc">该操作将归档病例，确定已死亡？</div>
				<div v-if="recoveryState===4" class="desc">该操作将归档病例，确定为其它康复情况？</div>
				<div v-if="recoveryState===3" class="line">
					<div class="label">死亡原因</div>
					<div class="value">
						<el-select v-model="diedCause" style="width:220px;margin-right: 40px;" size="small">
							<el-option v-for="item in [
								{label:'请选择',value:0},
								{label:'治愈中死亡',value:1},
								{label:'治愈前已处于濒死状态',value:2}
							]" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div v-if="recoveryState===3" class="line">
					<div class="label">死因描述</div>
					<div class="value">
						<el-input v-model="diedRemark" :rows="3" type="textarea"></el-input>
					</div>
				</div>
				<div v-if="recoveryState===4" class="line">
					<div class="label">其它描述</div>
					<div class="value">
						<el-input v-model="otherRemark" :rows="3" type="textarea"></el-input>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="infor" @click="close" size="small">取消</el-button>
				<el-button type="primary" @click="submit" size="small">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogState:false,
				
				diedCause:0,
				diedRemark:'',
				
				otherRemark:'',
			}
		},
		props:{
			recoveryState:{
				default:1
			}
		},
		mounted() {
			this.$nextTick(()=>{
				this.dialogState = true
			})
		},
		methods: {
			close(){
				this.$emit('submit',{type:'close',data:''})
			},
			submit(){
				if(this.recoveryState===2){
					console.log('治愈')
				}else if(this.recoveryState===3){
					if(this.diedCause===0){
						this.$message({
							message: '请选择死亡原因',
							type: 'error'
						});
						return ;
					}
					if(this.diedRemark.length===0){
						this.$message({
							message: '请输入死亡备注',
							type: 'error'
						});
						return ;
					}
				}else if(this.recoveryState===4){
					if(this.otherRemark.length===0){
						this.$message({
							message: '请输入其它描述',
							type: 'error'
						});
						return ;
					}
				}
				this.$emit('submit',{
					type:'success',
					data:{
						diedCause:this.diedCause,
						diedRemark:this.diedRemark,
						otherRemark:this.otherRemark,
					}
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.dialogRecoveryStateComp {
		::v-deep.el-dialog__body{
			padding-top:10px;
			.desc{
				padding:10px 18px;font-weight: bold;font-size: 16px;
			}
			.line{
				display: flex;padding:16px 0 0 0;
				.label{
					font-size: 14px;color:$fontColor;width:72px;text-align: right;margin-right: 18px;line-height: 32px;
				}
				.value{
					width:calc(100% - 132px);
				}
			}
		}
	}
</style>
